<template>
	<div>
		<router-view v-show="!error"></router-view>
		<Page500 v-show="error" />
	</div>
</template>

<script>
import Page500 from "../src/views/pages/Page500";
export default {
	name: "App",
	data() {
		return {
			error: false,
		};
	},
	components: {
		Page500,
	},
	methods: {
		onResize() {
			if (window.innerWidth > 1050 && window.innerWidth < 1250) {
				this.$store.commit("set", ["sidebarMinimize", true]);
				this.error = false;
			} else if (window.innerWidth <= 1050) {
				this.error = true;
			} else {
				this.error = false;
				this.$store.commit("set", ["sidebarMinimize", false]);
			}
		},
	},
	created() {
		window.addEventListener("resize", this.onResize);
		this.onResize();
		window.onbeforeunload = null;
	},
	destroyed() {
		window.removeEventListener("resize", this.onResize);
	},
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
